import { ReactComponent as CloseIcon } from '../../assets/images/close-icon.svg';
import { ReactComponent as InfoIcon } from '../../assets/images/info-icon.svg';

interface AgentOutdatedBannerProps {
  open: boolean;
  onClose: () => void;
  onCreateNewAgent: () => void;
}

const AgentOutdatedBanner = ({
  open,
  onClose,
  onCreateNewAgent,
}: AgentOutdatedBannerProps) => {
  if (!open) {
    return null;
  }

  return (
    <div className="overflow-hidden rounded-none border-b border-l-[3px] border-white/10 border-l-[#27AE60] bg-[#223047]/95 lg:rounded-md lg:border lg:border-white/10 lg:border-l-[3px] lg:border-l-[#27AE60]">
      <div className="relative flex items-center justify-between gap-2 px-3 py-2 pr-9">
        <div className="min-w-0 flex items-center gap-2">
          <InfoIcon className="h-[13px] w-[13px] text-[#27AE60] flex-shrink-0" />
          <p className="text-[11px] leading-4 text-white/90">
            <span className="font-semibold text-[#27AE60]">New version available.</span>{' '}
            <span>Update your agent to access new improvements.</span>
          </p>
        </div>

        <div className="flex items-center flex-shrink-0">
          <button
            type="button"
            onClick={onCreateNewAgent}
            className="h-[24px] px-1.5 rounded-sm text-white text-[10px] font-semibold transition-colors bg-[#27AE60] hover:bg-[#19875F]"
          >
            New Agent
          </button>
        </div>

        <button
          type="button"
          onClick={onClose}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-white/55 transition-colors hover:text-white"
          aria-label="Dismiss outdated agent banner"
        >
          <CloseIcon width="10" height="10" />
        </button>
      </div>
    </div>
  );
};

export default AgentOutdatedBanner;
